<template>
	
</template>
<script>
export default {
	name: "PaymentResStripe",
	components: {},
	created() {
		   this.$store.commit("showPopup", false);
		this.packages = this.$store.state.packages;
		this.currentSubs = this.getCurrentsubs();
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		this.doSubscribe()
	},
	methods: {
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		getCurrentsubs() {
			let cp = this.packages.find((ele) => ele.id == this.$route.params.pid);
			return cp.subscriptions.find((ele) => ele.id == this.$route.params.sid);
		},
		getcurrentpackage() {},
		getPaymentHref() {
			return (
				"/#/selectpayment-dsp/" +
				this.$route.params.sid +
				"/" +
				this.$route.params.pid
			);
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		doSubscribe() {
      this.$store.commit("setLoader", true);
       var dataToSend = {
              id: this.$route.params.sid,
            };
      this.$store
        .dispatch("stripeAddSubscription", dataToSend)
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.$router.push("/home");
		  this.$store.commit(
            "setNotification",
            "Subscription Added Sucessfully !! "
          );
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            " Error Occured Please try again  "
          );
          //this.$router.push("/login");
        });
    },
	},

	data() {
		return {
			checked: false,
			currentSubs: null,
			currentpackages: null,
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			password: "",
			packages: null,
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
<style scoped>
a.disabled {
	pointer-events: none;
	cursor: default;
}
.cursor-pointer {
	cursor: pointer;
}

.py-5{
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
 min-height: 100vh !important;
}

</style>
